import { FieldsEnum, FormsEnum, MessagesEnum } from 'app/shared/enums';
import {
  changeFieldValue,
  getCheckoutCarData,
  setMessageVisibility,
} from 'app/services/businessFunctionHelpers';

const vin = {
  checkoutCarVinChange(initialRun?: boolean) {
    const { vin } = getCheckoutCarData();
    const formattedVin = vin ? vin.toUpperCase() : '';

    if (vin) {
      changeFieldValue(FieldsEnum.CarVin, formattedVin, FormsEnum.CheckoutForm);
    }

    setMessageVisibility({
      key: MessagesEnum.ShortMotorcycleVinInfo,
      visible:
        Boolean(formattedVin) &&
        !formattedVin.includes('***') &&
        formattedVin.length >= 4 &&
        formattedVin.length < 17,
      formName: FormsEnum.CheckoutForm,
    });
  },
};

export default vin;
